import React, { HTMLAttributes } from "react";
import cn from "classnames";
import { ColumnSizeProps } from "../../types";
import { useColumnSizeProps } from "../../hooks";

export type GroupProps = HTMLAttributes<HTMLDivElement> &
  ColumnSizeProps & {
    inline?: boolean;
    margin?: string | number;
  };

export const useGroupProps = <T extends GroupProps>(props: T) => {
  const { col, sm, md, lg, xl, ...rest } = props;
  const output: string = cn({
    [`col-${col}`]: col,
    [`col-sm-${sm}`]: sm,
    [`col-md-${md}`]: md,
    [`col-lg-${lg}`]: lg,
    [`col-xl-${xl}`]: xl,
  });

  return { className: output, ...rest };
};

export const Group = <T extends GroupProps>(props: T) => {
  const { children, className, ...rest } = props;
  const colSize = useGroupProps(rest);

  return (
    <div className={cn("form-group", "mb-3", colSize, className)}>
      {children}
    </div>
  );
};

export default Group;
